import { Box, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'

import ToggleableSection from 'components/ToggleableSection'
import { useAppSelector } from 'store'

import { withContext } from '../Context'
import ACTScoreSelector from './ACTScoreSelector'
import PSATNMSQTScoreSelector from './PSATNMSQTScoreSelector'
import SATScoreSelector from './SATScoreSelector'
import TestScoreSelector from './TestScoreSelector'

type AcademicProfileSelectorProps = {
  segment: object
  onChange: (criteria: string, segmentName: string, value: any, operation: string) => void
}

export const AcademicProfileSelector = ({ segment, onChange }: AcademicProfileSelectorProps) => {
  const isSubjectTestsEnabled = useAppSelector(
    (state) => state.college.record?.Features?.SupportsSubjectTestSegmentation || false,
  )

  return (
    <ToggleableSection title="Academic Profile">
      <Box pt={2}>
        <Typography
          variant="subtitle2"
          color="textPrimary"
          className="title"
        >
          Test Score Ranges
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          Only students whose reported scores fall within the selected range will be included.
        </Typography>
      </Box>
      <ACTScoreSelector
        segment={segment}
        onChange={onChange}
        isSubjectTestsEnabled={isSubjectTestsEnabled}
      />

      <SATScoreSelector
        segment={segment}
        onChange={onChange}
        isSubjectTestsEnabled={isSubjectTestsEnabled}
      />

      <TestScoreSelector
        label="Pre-ACT"
        segmentName="PACT"
        segment={segment}
        onChange={onChange}
        min={1}
        max={35}
      />
      <PSATNMSQTScoreSelector
        segment={segment}
        onChange={onChange}
        isSubjectTestsEnabled={isSubjectTestsEnabled}
      />
      <TestScoreSelector
        label="PSAT 10"
        segmentName="PSAT10"
        segment={segment}
        onChange={onChange}
        min={320}
        max={1520}
        rangeStep={10}
      />
      <TestScoreSelector
        label="PSAT 8/9"
        segmentName="PSAT89"
        segment={segment}
        onChange={onChange}
        min={240}
        max={1440}
        rangeStep={10}
      />
    </ToggleableSection>
  )
}

AcademicProfileSelector.propTypes = {
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
}

export default withContext(AcademicProfileSelector)
